import axios from "axios";

export const submitApplication = async (loanApplicationID) => {
  return axios.post(
    `partner/api/v1/loan-applications/${loanApplicationID}/submit`,
  );
};

export const deselectLenderResponse = async (loanApplicationID) => {
  return axios.post(
    `partner/api/v1/loan-applications/${loanApplicationID}/deselect-lender-response`,
  );
};

export const markNoBidsReceived = async (loanApplicationID) => {
  return axios.post(
    `partner/api/v1/loan-applications/${loanApplicationID}/mark-no-bids-received`,
  );
};

export const markBidsRejectedByCustomer = async (loanApplicationID) => {
  return axios.post(
    `partner/api/v1/loan-applications/${loanApplicationID}/mark-bids-rejected-by-customer`,
  );
};

export const acceptAdvice = async (loanApplicationID) => {
  return axios.post(
    `partner/api/v1/loan-applications/${loanApplicationID}/accept-advisory`,
  );
};

export const withdrawAccept = async (loanApplicationID) => {
  return axios.delete(
    `partner/api/v1/loan-applications/${loanApplicationID}/accept-advisory`,
  );
};
